/* tslint:disable */

declare var Object: any;
export interface FileStorageInterface {
  "id"?: number;
}

export class FileStorage implements FileStorageInterface {
  "id": number;
  constructor(data?: FileStorageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FileStorage`.
   */
  public static getModelName() {
    return "FileStorage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FileStorage for dynamic purposes.
  **/
  public static factory(data: FileStorageInterface): FileStorage{
    return new FileStorage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FileStorage',
      plural: 'FileStorages',
      path: 'FileStorages',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/FileStorage.ts